import { personSystemAlias } from '../../utils/personnel';
import { displayPhone } from './phone';
import { money, salaryFields } from './money';
import recordFields from './recordFields.json';
import { fullName } from './list';
import { roleLabel } from '../../utils/roles';

export const columnCatalog = [
  ['nickname', 'Alias'], ['name', 'Nombre completo'], ['email', 'Mail'], ['operational_role', 'Rol'],
  ['employment_start_date', 'Fecha de inicio'], ['contract_company', 'Empresa contrato'],
  ['id', 'ID interno'], ['private_code', 'ID RRHH'], ['first_name', 'Nombre de pila'], ['last_name', 'Apellido'],
  ['phone', 'Teléfono'], ['cedula', 'Cédula'], ['active', 'Activo'], ['created_at', 'Fecha de alta del registro'],
  ['external_id', 'ID externo'], ['aliases', 'Nombres alternativos de importación'], ['hourly_rate', 'Valor hora'],
  ['agreed_hours', 'Horas acordadas'], ['schedule_type', 'Horario'], ['fixed_schedule', 'Horario semanal fijo'],
  ['driver_license_type', 'Libreta'], ['driver_license_expires_on', 'Vence libreta'],
  ['health_card_expires_on', 'Vence carné salud'], ['operation_categories', 'Categorías de operación'],
  ['biometric_status', 'Biometría'], ['document_status', 'Estado documental'], ['app_role', 'Acceso al sistema'],
  ['access_enabled', 'Habilitar acceso al sistema'], ['user_id', 'Usuario asociado'], ['avatar_url', 'Avatar URL'],
  ['is_sales_ref', 'Referente de ventas'],
];
for (const f of recordFields) {
  const existing=columnCatalog.find(c=>c[0]===f.key);
  if(existing) existing[1]=f.label; else columnCatalog.push([f.key,f.label]);
}
export const defaultColumns = ['nickname', 'name', 'email', 'operational_role', 'employment_start_date'];
export const alphabeticColumns = [...columnCatalog].sort((a, b) => a[1].localeCompare(b[1], 'es', { sensitivity: 'base' }));
const labels = Object.fromEntries(columnCatalog);
export function validColumns(value) {
  if (!Array.isArray(value)) return [...defaultColumns];
  const valid = [...new Set(value.filter(key => typeof key === 'string' && Object.hasOwn(labels, key)))];
  return valid.length ? valid : [...defaultColumns];
}
export function toggleColumn(current, key) {
  if (!Object.hasOwn(labels, key)) return current;
  if (current.includes(key)) return current.length === 1 ? current : current.filter(item => item !== key);
  const following = alphabeticColumns.slice(alphabeticColumns.findIndex(([item]) => item === key) + 1).find(([item]) => current.includes(item));
  const index = following ? current.indexOf(following[0]) : -1;
  const next = [...current]; next.splice(index < 0 ? next.length : index, 0, key); return next;
}
export function moveColumn(current, source, target) {
  if (source === target || !current.includes(source) || !current.includes(target)) return current;
  const index = current.indexOf(target);
  const next = current.filter(key => key !== source); next.splice(index, 0, source); return next;
}
export function columnValue(person, key) {
  const value = key === 'nickname' ? personSystemAlias(person) : person[key];
  if (['phone','emergency_phone'].includes(key)) return displayPhone(value);
  if (key === 'employment_end_date' && person.employee_status === 'Activo') return '—';
  if (key === 'agreed_hours') return value == null || value === '' ? '—' : Number(value).toLocaleString('es-UY', { maximumFractionDigits: 0 });
  if (salaryFields.includes(key)) return money(value);
  if (key === 'name') return fullName(person) || '—';
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Sí' : 'No';
  if (recordFields.find(f=>f.key===key)?.type==='date' || ['employment_start_date', 'driver_license_expires_on', 'health_card_expires_on', 'created_at'].includes(key)) {
    const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? `${match[3]}/${match[2]}/${match[1]}` : '—';
  }
  if (key === 'schedule_type') return value === 'fixed' ? 'Fijo' : 'Variable';
  if (key === 'biometric_status') return ['ok', 'linked'].includes(value) ? 'Vinculado' : 'No disponible';
  if (key === 'app_role') return person.access_enabled ? roleLabel(value) : 'Sin acceso';
  if (key === 'fixed_schedule' && Array.isArray(value)) return value.map(day => `${day.day}: ${day.start && day.end ? `${day.start}–${day.end}` : day.status || '—'}${day.activity ? ` (${day.activity})` : ''}`).join('; ') || '—';
  if (Array.isArray(value)) return value.join(', ') || '—';
  return String(value);
}

export function validWidths(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
  return Object.fromEntries(Object.entries(value).filter(([key, width]) => Object.hasOwn(labels, key) && typeof width === 'number' && Number.isFinite(width)).map(([key, width]) => [key, Math.max(90, Math.min(800, Math.round(width)))]));
}
